export const NO_AUTH_NEEDED = Symbol('NO_AUTH_NEEDED');
export const IS_PUBLIC = Symbol('IS_PUBLIC');
